module.exports = __webpack_public_path__ + "static/media/Certified_logo.46a8488e.png";